import { DataTable, Spinner } from '@dixa/lib-shared-habla';

import { BansByIpEndpointResult } from 'hooks/useBans';
import {
  BansByIpResponseDataBans,
  UsersGroupedByIpBan,
} from 'hooks/useBans/types';
import NO_RESULT_IMAGE from 'images/no-search-results.png';

import styles from '../bansTable.module.scss';

import { subTableColumns, tableColumns } from './bannedIpsColumns';

const Message = (props: {
  text: string;
  before?: JSX.Element;
  after?: JSX.Element;
}) => {
  return (
    <div className={styles.messageContainer}>
      {props.before && (
        <div className={styles.messageBefore}>{props.before}</div>
      )}

      <div className={styles.messageText}>{props.text}</div>

      {props.after && <div className={styles.messageAfter}>{props.after}</div>}
    </div>
  );
};

const LOADING_MESSAGE = (
  <Message
    text="Getting banned ip addresses ..."
    before={<Spinner size={32} />}
  />
);

const NO_BANNED_IPS_MESSAGE = (
  <Message
    text="There are no banned ip addresses."
    before={
      <img
        className={styles.messageImage}
        src={NO_RESULT_IMAGE}
        alt="No result image"
      />
    }
  />
);

const ERROR_MESSAGE = <Message text="Error" />;

type BannedIpsTableProps = Pick<
  BansByIpEndpointResult,
  | 'asyncStatus'
  | 'hasPreviousPage'
  | 'hasNextPage'
  | 'previousPage'
  | 'nextPage'
  | 'refreshItems'
  | 'items'
>;

export function BannedIpsTable({
  asyncStatus,
  hasPreviousPage,
  hasNextPage,
  previousPage,
  nextPage,
  refreshItems,
  items,
}: BannedIpsTableProps): JSX.Element {
  if (asyncStatus === 'loading') {
    return LOADING_MESSAGE;
  }

  if (asyncStatus === 'failed') {
    return ERROR_MESSAGE;
  }

  if (!items?.length) {
    return NO_BANNED_IPS_MESSAGE;
  }

  return (
    <DataTable<BansByIpResponseDataBans, UsersGroupedByIpBan>
      columns={tableColumns(refreshItems)}
      data={items}
      subTableColumns={subTableColumns}
      subTableDataSelector={({ bans }) => bans}
      paginationProps={{
        previousButtonDisabled: !hasPreviousPage,
        nextButtonDisabled: !hasNextPage,
        previousButtonClick: previousPage,
        nextButtonClick: nextPage,
      }}
    />
  );
}
